import { t } from '@lingui/macro';

import { LocationsEnum, SchedulesEnum } from '../../enums';

export const locationI18nStrings = (): Record<LocationsEnum, string> => {
  return {
    [LocationsEnum.HQ]: t({ id: 'vacancySummary.location.HQ' }),
    [LocationsEnum.AgencyNetwork]: t({ id: 'vacancySummary.location.agencyNetwork' }),
  };
};

export const scheduleI18nStrings = (): Record<SchedulesEnum, string> => {
  return {
    [SchedulesEnum.FullTime]: t({ id: 'global.schedules.FullTime' }),
    [SchedulesEnum.PartTime]: t({ id: 'global.schedules.PartTime' }),
    [SchedulesEnum.UNKNOWN]: t({ id: 'global.schedules.Unknown' }),
  };
};
